// ================================
// File: components/TeamAccess/GrantTeamAccessModal.jsx
// Minimal wrapper using the existing ModalApp shell and a body component
// ================================
import React, { Component } from 'react';
import ModalApp from '../SharedComponents/Modal';
import { Icon } from 'semantic-ui-react';
import GrantTeamAccessModalBody from './GrantTeamAccessModalBody';

class GrantTeamAccessModal extends Component {
    render() {
        return (
            <ModalApp
                name="grantTeamAccessModal"
                header={
                    <h4>
                        <Icon name="users" /> Grant Team Access
                    </h4>
                }
                body={<GrantTeamAccessModalBody />}
                size="large"
            />
        );
    }
}

export default GrantTeamAccessModal;